import React, { useState } from "react";
import { Card } from "primereact/card";
import ProgressBarElement from "./ProgressBarElement";
import { InputIcon } from "primereact/inputicon";
import { Dialog } from "primereact/dialog";

export default function CardElement(props) {
	const [showResp, setShowResp] = useState(false);

	const handleResp = () => {
		setShowResp(true)
	}

	const closePopup = () => {
		setShowResp(false)
	}

	return (
		<>
			<Card>
				<div className="cardHeader">
					<p className="cardTitle">{props.title}</p>
					<p className={props.progressStatus?.customStyle2}>{props.progressStatus?.colorStatus}</p>
				</div>
				{
					props.isProgressBar == true && (
						<div className="cardContent">
							<ProgressBarElement
								value={props.progressPercentage}
								style={props.progressStatus?.customStyle}
							></ProgressBarElement>
							<p className="progressPercentage">{props.progressPercentage}</p>
						</div>
					)
				}
				{
					props.isProgressBar == false && (
						<div className="cardContent">
							<p className="costValue">{props.costValue}</p>
							{
								props.sectionPermissions['Responsibilities'] &&
								<InputIcon
									className="pi pi-angle-double-right pointer"
									onClick={handleResp}
								/>
							}
						</div>
					)
				}
			</Card>
			<Dialog
				header="My Responsibilities"
				visible={showResp}
				position="right"
				onHide={() => closePopup()}
				draggable={false}
				resizable={false}
				className="table-dialog width-32"
			>
				<div>
					{
						props.pendingResponsibility != undefined && props.pendingResponsibility.length > 0 && props.pendingResponsibility.map((item, index) => (
							<li key={index} className="form-label text-left">
								{item.resp}
							</li>
						))
					}
				</div>
			</Dialog>
		</>
	);
}
